var divider_viewer_default = {
  "divider-container": "NgX59",
  "divider-container--double": "ZUtSu",
  "divider": "u802e",
  "divider--single": "wa8yU",
  "divider--double": "nssd0",
  "divider--dashed": "_0q5sX",
  "divider--dotted": "iRyqz",
  "divider--small": "bjaFC",
  "divider--medium": "gFdOi",
  "divider--large": "GWyhG",
  "divider--left": "_-3qu6",
  "divider--center": "fBKAb",
  "divider--right": "kEUPE",
  "svgFixerContainer": "vM8xR",
  "emptyChar": "X6Rhs"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
